import React from 'react';
import styled from 'styled-components';
import { default as SearchIcon } from '../icons/Search';
import buttonMutedStyle from '../utils/buttonMutedStyle';
import __ from '../utils/translator';
import Color from 'color';

const MIN_SEARCH_QUERY_LENGTH = 2;

function noop() {}

export default ({ isOpen, onChange, value, handleOpenChange, onSubmit, inputRef = noop, ...props }) => {
  let searchInputReference = null;

  const handleSubmit = e => {
    e.preventDefault();

    if (isOpen) {
      if (value.length > MIN_SEARCH_QUERY_LENGTH) {
        if (searchInputReference) {
          searchInputReference.blur();
        }
        onSubmit();
      }
    } else {
      if (searchInputReference) {
        searchInputReference.focus();
      }
    }

    handleOpenChange( ! isOpen);
  };

  return (
    <Container {...props}>
      <form onSubmit={handleSubmit}>
        <SearchInput
          ref={ref => inputRef(searchInputReference = ref)}
          open={isOpen}
          type="text"
          maxLength={150}
          onChange={e => onChange(e.target.value)}
          onClick={() => ! isOpen && handleOpenChange(true)}
          value={value} />
      </form>
      <button
        style={{ ...buttonMutedStyle, lineHeight: 1 }}
        onClick={handleSubmit}>
        <SearchIcon style={{ width: '1.25rem', height: '1.25rem', }} />
      </button>
    </Container>
  )
};

const Container = styled.div`
  display: flex;
  align-items: center;
  padding-right: 1rem;
`;

const SearchInput = styled.input`
  width: ${props => props.open ? '10rem' : '4.5rem'};
  margin-right: .5rem;
  padding-top: .25rem;
  padding-bottom: .25rem;
  text-align: ${props => props.open ? 'left' : 'right'};
  border-width: 0 0 .0625rem 0;
  border-color: ${props => props.open ? Color(props.theme.primaryIconColor).alpha(.6).toString() : 'transparent'};
  outline: none;
  color: ${({ value, theme }) => value.length <= MIN_SEARCH_QUERY_LENGTH ? Color(theme.primaryIconColor).alpha(.6).toString() : 'inherit'};
  background-color: transparent;

  &::placeholder {
    color: inherit;
    font-size: 1rem;
    text-align: ${props => props.open ? 'left' : 'right'};
    text-transform: uppercase;
  }
`;
